export const CLIENT_FLEET_MAINTENANCE_CONFIG_KEY = 'clients.allowFleetMaintenance';
export const CLIENT_PRE_TARE_REQUESTS_CONFIG_KEY = 'clients.allowPreTareRequests';
/** When true, managers may edit client/truck/product/port/weighbridge/transaction type/status in edit load modal. */
export const MANAGER_LOAD_DETAILS_EDIT_CONFIG_KEY = 'allow_manager_edit_load_details';
/** When true, only ADMIN may sign in and use authenticated APIs (except public maintenance-status). */
export const SYSTEM_MAINTENANCE_MODE_CONFIG_KEY = 'system.maintenance.enabled';
/** JSON: { timeZone, dateFormat, dateTimeFormat, timeFormat } for UI date/time display. */
export const SYSTEM_LOCALE_CONFIG_KEY = 'system.locale';
